import { get, post } from "./api-request";

type Commission = {
    outageCheckout?: number
    outageClean?: number
}

export async function getOutage(): Promise<Commission> {
    return (await get("/cashier/api/shop-setting/outage/get")).data;
}

export async function setOutage(data: Commission): Promise<any> {
    return (await post("/cashier/api/shop-setting/outage/set", data)).data;
}

export async function getAddressData(): Promise<AddressOption[]> {
    return (await get("/cashier/api/sysconfig/address-all-list")).data;
}

// 获取店铺系统配置
export async function getShopConfig(): Promise<any> {
    return (await get("/cashier/api/shop/config")).data;
}

export async function getServerTime(): Promise<DateTime> {
    const res = await get("/cashier/api/system/time");
    console.log("# 服务器时间: ", res.data);
    return new Date(res.data);
}

//获取团购店铺信息
export async function groupBuyShop(): Promise<GroupBuyShopInfoMap> {
    return (await get("/cashier/api/shop-setting/group_buy_shop/get")).data;
}

// 空调参数默认设置查询
export async function getAcDefaultSetting(): Promise<AcDefaultSetting> {
    // 发送GET请求，获取收银台默认设置
    return (await get("/cashier/api/shop-setting/ac_default/get")).data;
}

//空调参数默认设置查询 set
export async function setAcDefaultSetting(data: AcDefaultSetting): Promise<any> {
    return (await post("/cashier/api/shop-setting/ac_default/set", data)).data;
}

//空调参数默认设置查询 set
export async function acOpt(data: AcOptRequest): Promise<any> {
    return (await post("/cashier/api/shop/iot/ac/opt", data)).data;
}

//桌子开启或者关闭空调
export async function acDeskOpt(data: AcDeskOptRequest): Promise<any> {
    return (await post("/cashier/api/shop/iot/ac/opt/desk", data)).data;
}

//空调参数默认设置查询 set
export async function getShopSetting(data: ShopSettings): Promise<any> {
    return (await post("/cashier/api/shop/iot/ac/opt", data)).data;
}




